import React from 'react';

import {
  Box,
  CardActionArea,
  Typography
} from '@mui/material';

import LocationOnIcon from '@mui/icons-material/LocationOn';

import { NextLinkComposed } from '../components/Link';


const RequestCard = ({ job }) => {

  return (
    <CardActionArea
      sx={{ px: 2, py: 4 }}
      component={NextLinkComposed}
      to={{ pathname: `/quotes-requested${job.detail_path}` }}
    >
      <Box
        flexDirection="column"
        justifyContent="flex-start"
        alignContent="flex-start"
        fontFamily="fontFamily"
      >
        <Box
          display="flex"
          justifyContent="space-between"
        >
          <Box fontSize="subtitle1.fontSize">
            {job.car_string}
          </Box>
          <Typography variant="body2">
            {job.created}
          </Typography>
        </Box>
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
        >
          <Box flexGrow={1}>
            <Typography variant="h5" gutterBottom>
              {job.name}
            </Typography>
            {job.description ?
              <Box fontStyle="italic" fontSize="body2.fontSize">
                &quot;{job.description}&quot;
              </Box> : 
              <Box fontStyle="italic" fontSize="body2.fontSize">
                The user didn&apos;t provide a description
              </Box>
            }
          </Box>

          <Box ml={2} display="flex" flexDirection="row" alignItems="center">
            <Box
              flexDirection="column"
              justifyContent="center"
              p={2}
              mr={1}
              width={80}
              color={"white"}
              bgcolor="grey.600"
            >
              <Box
                pb={0.25}
                textAlign="center"
                fontSize="18px"
                fontWeight={500}>{job.estimate_count}</Box>
              <Box textAlign="center">{job.estimate_count == 1 ? `Quote` : `Quotes`}</Box>
            </Box>
            <Box
              flexDirection="column"
              justifyContent="center"
              p={2}
              width={100}
              color={"white"}
              bgcolor="primary.light"
            >
              <Box
                pb={0.25}
                textAlign="center"
                fontSize="18px"
                fontWeight={500}>R{job.avg_estimate}</Box>
              <Box textAlign="center">Average</Box>
            </Box>
          </Box>
        </Box>
        
        <Box mt={2} display="flex" alignItems="center" textOverflow="ellipsis">
          <LocationOnIcon fontSize="small" />
          <Box ml={1}>Less than {job.distance} from {job.where}</Box>
        </Box>
      </Box>
    </CardActionArea>
  )
}

export default RequestCard;
